//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ManualLiquidation
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x015BBC6cA60390f3b48c63773f1b7022B14cF76D)
 */
export const manualLiquidationAbi = [
  {
    type: 'constructor',
    inputs: [{ name: '_repository', internalType: 'address', type: 'address' }],
    stateMutability: 'nonpayable',
  },
  { type: 'error', inputs: [], name: 'InvalidSiloRepository' },
  { type: 'error', inputs: [], name: 'NotSilo' },
  { type: 'error', inputs: [], name: 'RepayApprovalFailed' },
  { type: 'error', inputs: [], name: 'RepayFailed' },
  { type: 'error', inputs: [], name: 'UsersMustMatchSilos' },
  {
    type: 'event',
    anonymous: false,
    inputs: [
      { name: 'silo', internalType: 'address', type: 'address', indexed: true },
      { name: 'user', internalType: 'address', type: 'address', indexed: true },
    ],
    name: 'LiquidationExecuted',
  },
  {
    type: 'function',
    inputs: [],
    name: 'SILO_REPOSITORY',
    outputs: [
      { name: '', internalType: 'contract ISiloRepository', type: 'address' },
    ],
    stateMutability: 'view',
  },
  {
    type: 'function',
    inputs: [
      { name: '_user', internalType: 'address', type: 'address' },
      { name: '_silo', internalType: 'contract ISilo', type: 'address' },
    ],
    name: 'executeLiquidation',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    inputs: [
      { name: '_user', internalType: 'address', type: 'address' },
      { name: '_assets', internalType: 'address[]', type: 'address[]' },
      {
        name: '_receivedCollaterals',
        internalType: 'uint256[]',
        type: 'uint256[]',
      },
      {
        name: '_shareAmountsToRepaid',
        internalType: 'uint256[]',
        type: 'uint256[]',
      },
      { name: '_flashReceiverData', internalType: 'bytes', type: 'bytes' },
    ],
    name: 'siloLiquidationCallback',
    outputs: [],
    stateMutability: 'nonpayable',
  },
  { type: 'receive', stateMutability: 'payable' },
] as const

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x015BBC6cA60390f3b48c63773f1b7022B14cF76D)
 */
export const manualLiquidationAddress = {
  1: '0x015BBC6cA60390f3b48c63773f1b7022B14cF76D',
} as const

/**
 * [__View Contract on Ethereum Etherscan__](https://etherscan.io/address/0x015BBC6cA60390f3b48c63773f1b7022B14cF76D)
 */
export const manualLiquidationConfig = {
  address: manualLiquidationAddress,
  abi: manualLiquidationAbi,
} as const
